const About = () => {
    return (
        <section id="nosotros" className="py-24 bg-dark text-white relative overflow-hidden">
            <div className="absolute top-0 right-0 -mt-20 -mr-20 w-96 h-96 rounded-full pointer-events-none"
                style={{ background: 'radial-gradient(circle, rgba(124,58,237,0.15) 0%, transparent 70%)', filter: 'blur(60px)' }} />
            <div className="absolute bottom-0 left-0 -mb-20 -ml-20 w-96 h-96 rounded-full pointer-events-none"
                style={{ background: 'radial-gradient(circle, rgba(139,92,246,0.10) 0%, transparent 70%)', filter: 'blur(60px)' }} />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="grid lg:grid-cols-2 gap-16 items-center">
                    <div>
                        <span className="inline-block bg-brand-500/15 text-brand-400 font-bold uppercase tracking-widest text-xs px-4 py-1.5 rounded-full mb-4 border border-brand-500/20">
                            Por que elegirnos
                        </span>
                        <h3 className="text-3xl md:text-4xl font-black mb-6 leading-tight">
                            No somos solo un software,<br />
                            <span className="text-brand-400">somos el sistema nervioso de tu negocio.</span>
                        </h3>
                        <p className="text-white/45 mb-8 text-lg leading-relaxed">
                            Sabemos que en cualquier negocio el tiempo es dinero y cada servicio que no se cobra es una perdida directa. Nexo Pro elimina el caos, los errores de cobro y la desorganizacion con una plataforma pensada para operar, no para complicar.
                        </p>

                        <ul className="space-y-6">
                            <li className="flex items-start gap-4">
                                <div className="flex-shrink-0 w-12 h-12 glass rounded-full flex items-center justify-center mt-1">
                                    <i data-lucide="shield-check" className="text-brand-400 w-6 h-6"></i>
                                </div>
                                <div>
                                    <h5 className="text-xl font-bold mb-1">Cero Perdidas de Inventario</h5>
                                    <p className="text-white/40">Cada producto que sale del inventario queda registrado y cobrado automaticamente. Se acabo el stock que desaparece sin aparecer en la factura.</p>
                                </div>
                            </li>
                            <li className="flex items-start gap-4">
                                <div className="flex-shrink-0 w-12 h-12 glass rounded-full flex items-center justify-center mt-1">
                                    <i data-lucide="trending-up" className="text-brand-400 w-6 h-6"></i>
                                </div>
                                <div>
                                    <h5 className="text-xl font-bold mb-1">Flujo de Caja Optimizado</h5>
                                    <p className="text-white/40">El dueno sabe exactamente cuanto dinero tiene detenido en inventario y que productos no se mueven. Compras inteligentes, no compras por intuicion.</p>
                                </div>
                            </li>
                            <li className="flex items-start gap-4">
                                <div className="flex-shrink-0 w-12 h-12 glass rounded-full flex items-center justify-center mt-1">
                                    <i data-lucide="calendar" className="text-brand-400 w-6 h-6"></i>
                                </div>
                                <div>
                                    <h5 className="text-xl font-bold mb-1">Orden Total en la Agenda</h5>
                                    <p className="text-white/40">Se acaba el caos de varios clientes llegando al mismo tiempo sin personal disponible. Cada cita tiene su slot, su responsable asignado y su recordatorio automatico.</p>
                                </div>
                            </li>
                            <li className="flex items-start gap-4">
                                <div className="flex-shrink-0 w-12 h-12 glass rounded-full flex items-center justify-center mt-1">
                                    <i data-lucide="eye" className="text-brand-400 w-6 h-6"></i>
                                </div>
                                <div>
                                    <h5 className="text-xl font-bold mb-1">Cliente Informado, Negocio Tranquilo</h5>
                                    <p className="text-white/40">El cliente ve en tiempo real el avance de su servicio, deja notas al agendar y recibe las observaciones del equipo al cerrar. Menos llamadas, menos incertidumbre.</p>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div className="relative">
                        <div className="aspect-[4/5] rounded-3xl overflow-hidden shadow-2xl shadow-brand-900/30">
                            <img
                                src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                                alt="Equipo gestionando su negocio con Nexo Pro"
                                className="w-full h-full object-cover"
                            />
                            <div className="absolute inset-0" style={{ background: 'linear-gradient(to top, rgba(9,9,15,0.5) 0%, transparent 60%)' }} />
                        </div>
                        {/* Badge flotante */}
                        <div className="absolute -bottom-6 -left-6 glass p-5 rounded-2xl shadow-xl max-w-xs hidden sm:block border border-white/10">
                            <div className="flex items-center gap-3 mb-2">
                                <div className="w-9 h-9 bg-gradient-to-br from-brand-600 to-brand-500 rounded-lg flex items-center justify-center flex-shrink-0">
                                    <i data-lucide="zap" className="text-white w-5 h-5"></i>
                                </div>
                                <span className="text-white font-black text-base">Tu propia Landing</span>
                            </div>
                            <p className="text-white/50 text-xs leading-relaxed">Cada negocio registrado recibe su pagina web automatica con colores, servicios y datos propios. Presencia digital desde el dia uno.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
